
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/auth";
import { UserPlus } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";

const ReferralCard = () => {
    const { user } = useAuth();
    const { toast } = useToast();
    const { t } = useTranslation('dashboard');

    if (!user) return null;

    const referralUrl = `${window.location.origin}/auth?mode=signup&ref=${user.id}`;

    const getWhatsAppLink = () => {
        const text = encodeURIComponent(`I'm inviting you to join WhatsGood HK! Sign up using my link:`);
        return `https://wa.me/?text=${text}%20${encodeURIComponent(referralUrl)}`;
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(referralUrl);
        toast({
            title: t("profile.referral.copiedSuccess"),
            description: t("profile.referral.copiedDescription"),
        });
    };

    return (
        <section className="overflow-hidden rounded-md border border-brand-cloud bg-white shadow-sm">
            <div className="border-b border-brand-cloud p-6 md:p-8">
                <h2 className="public-section-title">{t("profile.referral.title")}</h2>
                <p className="mt-2 text-sm leading-6 text-brand-slate">{t("profile.referral.description")}</p>
            </div>
            <div className="space-y-4 p-6 md:p-8">
                <div className="flex flex-col gap-2 sm:flex-row">
                    <Input value={referralUrl} readOnly />
                    <Button onClick={copyToClipboard} variant="secondary">{t("profile.referral.copy")}</Button>
                </div>
                <Button asChild className="w-full">
                    <a
                        href={getWhatsAppLink()}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Refer a Friend on WhatsApp"
                    >
                        <UserPlus className="mr-2 h-4 w-4" />
                        {t("profile.referral.referViaWhatsapp")}
                    </a>
                </Button>
            </div>
        </section>
    );
};

export default ReferralCard;
